import clsx, { ClassValue } from "clsx";
import styles from "./styles.module.css";

export type SkeletonKind =
  | "card"
  | "tile"
  | "title"
  | "subtitle"
  | "paragraph"
  | "button"
  | "buttonText"
  | "input"
  | "inputWithoutLabel"
  | "header"
  | "image"
  | "avatar"
  | "editor"
  | "absolute"
  | "pagination"
  | "tag"
  | "icon";

type Props = Readonly<{
  kind?: SkeletonKind;
  className?: ClassValue;
  amount?: number;
}>;

export const LoadingSkeleton = ({ kind, className, amount = 1 }: Props): JSX.Element => {
  const classes = clsx({
    "h-40 w-40 rounded-md": kind === "card",
    "h-40 w-full rounded-md sm:h-32": kind === "tile",
    "h-10 w-full rounded-sm": kind === "title",
    "h-8 min-h-8 w-full rounded-sm": kind === "subtitle",
    "h-5 w-full rounded-sm": kind === "paragraph",
    "min-h-button w-full max-w-button rounded-sm": kind === "button",
    "h-5 w-full max-w-40 rounded-sm": kind === "buttonText",
    "h-20 w-full rounded-sm": kind === "input",
    "h-12 w-full rounded-sm": kind === "inputWithoutLabel",
    "h-24 w-full rounded-sm": kind === "header",
    "h-40 w-full rounded-sm": kind === "image",
    "h-20 w-20 rounded-full": kind === "avatar",
    "h-96 w-full rounded-sm": kind === "editor",
    "absolute -inset-[1px] z-[11] h-[calc(100%+2px)] w-[calc(100%+2px)] rounded-md": kind === "absolute",
    "h-7 w-full max-w-36 rounded-xs": kind === "pagination",
    "h-6 w-6 rounded-sm": kind === "icon",
    "h-7 w-full rounded-[1.5rem]": kind === "tag",
    "h-full w-full rounded-sm": !kind,
  });

  return (
    <>
      {Array.from({ length: amount ?? 1 }).map((_, index) => (
        <div key={index} className={clsx(styles.loading, classes, className)} />
      ))}
    </>
  );
};
